import { render } from "./ObjectFitPage.vue?vue&type=template&id=8d939b68&ts=true"
import script from "./ObjectFitPage.vue?vue&type=script&lang=ts"
export * from "./ObjectFitPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__